const {genHash} = require("../utils/utils");

class InvoiceItem {

    constructor({
                    id = genHash(4),
                    description = '',
                    unitPrice = 0,
                    unitName = '',
                    vat = 0.19,
                    discount = 0,
                    quantity = 1,
                } = {}) {

        this.id = id;
        this.description = description;
        this.unitPrice = Number(unitPrice);
        this.unitName = unitName;
        this.vat = Number(vat);
        this.discount = Number(discount);
        this.quantity = Number(quantity);
    }

    get net(){
        return Math.round((1 - this.discount) * this.unitPrice * this.quantity * 100) / 100
    }

    get gross(){
        return Math.round(this.net * (1 + this.vat)  * 100) / 100
    }

    toFirestore() {
        return {
            description: this.description,
            unitPrice: this.unitPrice,
            unitName: this.unitName,
            vat: this.vat,
            discount: this.discount,
            quantity: this.quantity,
        }
    }

    static parseFirestore(item, key) {
        return new InvoiceItem({
            ...item,
            id: key ? key : item.id,
        })
    }

    isSame(obj = {}) {
        return JSON.stringify(obj) === JSON.stringify(this)
    }

    static fromFirestore(fsSnap) {
        let data = {};
        if (fsSnap) {
            Object.keys(fsSnap).forEach((key) => {
                // the firestore object is not null
                if (fsSnap[key]) {
                    data[key] = InvoiceItem.parseFirestore(...fsSnap[key], key)
                }
            });
        }

        return data
    }
}

module.exports = InvoiceItem;